import { ANIMATIONS } from 'Pods/ThreeDStudio/Services/Constants/animations'
import { PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * The library entries an engine can run. Tripo3D only retargets onto its own
 * preset clips, so entries without a `tripoPreset` are dropped for it; Meshy
 * runs the whole library. Single source of the support rule: the Animate tab
 * renders this list and resetAnimationUnsupportedByProvider clears a selection
 * that falls outside it, so the grid and the payload cannot disagree.
 *
 * @param {string} [provider] - Provider id, e.g. PROVIDER.TRIPO3D.
 * @returns {Object[]} - Entries from ANIMATIONS the provider can animate.
 */
export const animationsForProvider = provider => (
  provider === PROVIDER.TRIPO3D
    ? ANIMATIONS.filter(({ tripoPreset }) => tripoPreset)
    : ANIMATIONS
)
